import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Nav from "../components/Nav";
import { api } from "../lib/api";
import { Sparkles, BookOpen, Trophy, GraduationCap, Flame, Zap, Plus, LibraryBig, Lock } from "lucide-react";

const ICONS = {
  sparkles: Sparkles,
  "book-open": BookOpen,
  trophy: Trophy,
  "graduation-cap": GraduationCap,
  flame: Flame,
  zap: Zap,
  plus: Plus,
  "library-big": LibraryBig,
};

export default function Achievements() {
  const [data, setData] = useState({ stats: {}, achievements: [] });

  useEffect(() => {
    api.get("/achievements").then(({ data }) => setData(data));
  }, []);

  const earnedCount = data.achievements.filter((a) => a.earned).length;

  return (
    <div className="min-h-screen grain-bg" data-testid="achievements-page">
      <Nav />
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-10">
        <div className="mb-8">
          <div className="brutal-badge bg-brand-yellow mb-3"><Trophy className="w-3.5 h-3.5" strokeWidth={3} /> Achievements</div>
          <h1 className="font-display text-4xl md:text-5xl font-bold text-brand-navy">Your trophy shelf</h1>
          <p className="text-brand-navy/70 mt-2 text-lg">
            <span className="font-bold text-brand-pink">{earnedCount}</span> of {data.achievements.length} unlocked
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {data.achievements.map((a, i) => {
            const Icon = ICONS[a.icon] || Sparkles;
            return (
              <motion.div
                key={a.id}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.04 }}
                data-testid={`achievement-${a.id}`}
                className={`brutal-card p-5 relative overflow-hidden ${a.earned ? "bg-white" : "bg-brand-cream/60"}`}
              >
                {!a.earned && (
                  <Lock className="w-4 h-4 absolute top-3 right-3 text-brand-navy/40" strokeWidth={3} />
                )}
                <div
                  className={`w-14 h-14 rounded-2xl border-2 border-brand-ink shadow-brutal flex items-center justify-center mb-3 ${a.earned ? "" : "grayscale opacity-60"}`}
                  style={{ backgroundColor: a.color }}
                >
                  <Icon className="w-7 h-7 text-brand-navy" strokeWidth={2.5} />
                </div>
                <div className={`font-display font-bold text-lg ${a.earned ? "text-brand-navy" : "text-brand-navy/60"}`}>{a.title}</div>
                <p className={`text-sm mt-1 ${a.earned ? "text-brand-navy/70" : "text-brand-navy/50"}`}>{a.desc}</p>
                <div className="mt-3 h-2 border-2 border-brand-ink rounded-full bg-brand-peach overflow-hidden">
                  <div
                    className={`h-full ${a.earned ? "bg-brand-mint" : "bg-brand-yellow"}`}
                    style={{ width: `${Math.min(100, a.progress * 100)}%` }}
                  />
                </div>
                <div className="text-xs font-bold text-brand-navy/60 mt-1">
                  {a.current} / {a.threshold}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
